'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.styles = exports.styleChild = exports.styleRoot = void 0;
exports.styleRoot = 'kvfysmfp';
exports.styleChild = 'ufhsfnkm';
exports.styles = '.'
  .concat(exports.styleRoot, '{overflow:hidden;touch-action:none}.')
  .concat(exports.styleChild, '{transform-origin: 0 0}');
